import React from 'react';
import { useState,useEffect } from 'react';  
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
  List,
  ListItem,
  ListItemText,
  Typography,
  Alert,
  TablePagination,
  useMediaQuery,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Toolbar,
  Grid,
  Pagination,
  Button,
  Checkbox
} from '@mui/material';
import styles from './DetailsList.module.css';
import { Box, border } from '@mui/system';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from '@mui/material/styles';
import MyModal from "../../components/session_expired"
import MyLodder from '../lodder';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  boxShadow : "none"
  // textAlign: 'center',
  // color: theme.palette.text.secondary,
}));

const customScrollbarStyles = {
  width : "100%",
  scrollbarWidth : "thin",
  scrollbarColor: 'rgba(170,170,170,0.4) transparent', 
};
// Corrected date select handlers -30-07-24 - Dev Srini 
const DetailsList = ({ 
  data, fromDate, toDate, handleSubmit, handleDownload, 
  handlePDFDownload ,handleToDateChange, handleFromDateChange,showmodal,showlodder,
  startYear , endYear 
  }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isSmallScreen1 = useMediaQuery("(max-width : 400px)")
  const [page, setPage] = useState(0);
  const [mpage, setMPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [mdata,setMdata] = useState([]) 

  
  useEffect(() => {
    if (!data || data.length === 0) {
      setMdata([]);
      return;
    }

    // sort latest → oldest
    const sortedData = [...data].sort(
      (a, b) => new Date(b.VOUCHERDATE) - new Date(a.VOUCHERDATE)
    );

    const rowsPerPage = 5;
    const startIndex = (mpage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const newArr = sortedData.slice(startIndex, endIndex);

    setMdata(newArr);
  }, [mpage, data]);

  const  handlePageChange = (event, newpage) => { 
    setPage(newpage); 
  }
  const  handleMPageChange = (event, newpage) => { 
    setMPage(newpage); 
  }

  const handleRowsPerPageChange =(event) => { 
    setRowsPerPage(+event.target.value); 
    setPage(0); 
  } 
  
  if (!data) {
    return <CircularProgress />
  }
  // amded field name Date - 23-07-24 - Dev Srini
  const columns = [
    { id: 'PUNCH_TIME', label: 'Date',  },
    { id: 'TRANS_TYPE1', label: 'Voucher',  },
    { id: 'VOUCHERNO', label: 'Voucher No',  },
    // { id: 'COCD', label: 'Code' },
    { id: 'NARRATION', label: 'Narration' },
    { id: 'GATEWAYID', label: 'Cheque/Ref No' },
    { id: 'DR_AMT', label: 'Debit' },
    { id: 'CR_AMT', label: 'Credit' },
    { id: 'CLOSING_AMT', label: 'Balance',  },
  ];

  return (<>
    {
      isSmallScreen ?
        <>
          <Grid container className={styles.gridSmallScreen} rowSpacing={3} item columnSpacing={1} xs={12}>
            <Grid item xs={6} sx={{ border: "none" }} >
              <Item className={styles.item}  >
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="From"
                    size="small"
                    sx={{ 
                      width: "100%", 
                      height: 40, 
                      "& .MuiInputBase-root": { height: 40 }, 
                      backgroundColor: "#131E2E", 
                      marginRight: 1, 
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" } }}
                    value={dayjs(fromDate)}
                    onChange={(newValue) => handleFromDateChange(newValue)} // adjust date value -30-07-24 - Dev Srini
                    renderInput={(props) => (
                      <TextField
                        {...props}
                        sx={{
                          width: 170,
                          height: 40,
                          '& .MuiInputBase-root': { height: 40 },
                          backgroundColor: '#131E2E',
                          marginRight: 1,
                          '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                        }}
                      />
                    )}
                    format="DD/MM/YYYY"
                    minDate={dayjs(`${startYear}-04-01`)}
                    maxDate={dayjs(`${endYear}-03-31`)}
                    // Fn year range controlled -30-07-24 - Dev Srini 
                  />
                </LocalizationProvider>
              </Item>
            </Grid>
            <Grid item xs={6}>
              <Item className={styles.item}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="To"
                    size="small"
                    sx={{ 
                      width: "100%", 
                      height: 40, 
                      "& .MuiInputBase-root": { height: 40 }, 
                      backgroundColor: "#131E2E", 
                      marginRight: 1, 
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" } }}
                    value={dayjs(toDate)}
                    onChange={(newValue) => handleToDateChange(newValue)} // adjusted date value -30-07-24 - Dev Srini
                    renderInput={(props) => (
                      <TextField
                        {...props}
                        sx={{
                          width: 170,
                          height: 40,
                          '& .MuiInputBase-root': { height: 40 },
                          backgroundColor: '#131E2E',
                          marginRight: 1,
                          '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                        }}
                      />
                    )}
                    format="DD/MM/YYYY"
                    minDate={dayjs(`${startYear}-04-01`)}
                    maxDate={dayjs(`${endYear}-03-31`)}
                    // Fn year range controlled -30-07-24 - Dev Srini
                  />
                </LocalizationProvider>
              </Item>
            </Grid>
            {/* <Grid item xs={6}>
              <Item className={styles.item}>
                <TextField
                  label="Client Code"
                  variant="outlined"
                  placeholder='Client Code'
                  size='small'
                  sx={{ width: "100%", "& .MuiOutlinedInput-notchedOutline": { border: "none" }, background: "#131E2E", marginRight: "1px" }}
                />
              </Item>
            </Grid> */}
            {/* <Grid item xs={6}>
              <Item className={styles.item}>
                <TextField
                  label="Exchange"
                  variant="outlined"
                  placeholder='Exchange'
                  size='small'
                  sx={{ width: "100%", "& .MuiOutlinedInput-notchedOutline": { border: "none" }, background: "#131E2E", marginRight: "1px" }}
                />
              </Item>
            </Grid> */}
            {/* <Grid item xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox sx={{ color: "#0B1420", marginLeft: "20px" }} />}
                    label="With Margin A/C"
                  />
                </FormGroup>
            </Grid> */}
            {/* Added submit in mobile view - 23-07-24 - Dev Srini */}
            <Grid item xs={12} >
              <Item className={styles.item}>
                <Button
                  fullWidth
                  onTouchStart={() => handleSubmit()}
                >Submit</Button>
              </Item>  
            </Grid>

            <Grid item xs={6}>
              <Item className={styles.item} >
                {/* <Button
                  variant="outlined"
                  size="medium"
                  sx={{ 
                    width: "100%", height: 40, marginRight: 1
                    , backgroundColor: "transparent", color: "#F3DA5E"
                  }}
                  className={styles.outlinedButton}
                  onClick={() => handleDownload()}
                  fullWidth
                >Download</Button> */}
                {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
                <Button onTouchStart={() => handleDownload()}
             sx={{background : "transparent" , color : "#F3D45E" , textDecoration : "underline"}}>Download CSV</Button>
              </Item>
            </Grid>
            <Grid item xs={6}  sx={{display : "flex" , justifyContent : "end"}}>
              <Item className={styles.item}>
                {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
                <Button onTouchStart={() => handlePDFDownload()}
             sx={{background : "transparent" , color : "#F3D45E" , textDecoration : "underline"}}>Download PDF</Button>
              </Item>
            </Grid>
          </Grid>
          {data.length == 0 ? (
            <Table>
            <TableRow  style={{display:'flex',justifyContent:'center',marginTop : "20px"}}>          
            <Alert severity="warning" style={{background:'transparent'}}>No Data found !</Alert>
          </TableRow>
          </Table>
          ):(<Table sx={{ width: isSmallScreen1 ? "90%" : "92%", background: "#0B1420", margin: "20px 20px 0px 20px", borderRadius: "10px" }}>
            <TableBody>
                  {mdata?.map((item ,index)=>{
                    
                    return(
                      <TableRow>
                        <TableCell sx={{ borderBottom : "1px solid #000000",width : "50%",verticalAlign : "top"}} >
                          <Grid display="flex" flexWrap= "wrap" alignItems="center">
                            <Typography sx={{ marginRight: "10px" }}>{item.PUNCH_TIME && new Date(item.PUNCH_TIME).toLocaleDateString('en-GB')}</Typography>
                          <Typography style={{color : "grey", fontSize : "10px", textWrap : "nowrap"}}>{item.COCD}</Typography>
                          </Grid>
                          {/* adjusted overlapping table values - 23-07-24 - Dev Srini */}
                          <Typography style={{color : "grey", fontSize : "12px", wordBreak: "break-word"}}>{item.NARRATION}</Typography>
                        </TableCell>
                        <TableCell sx={{textAlign : "right",borderBottom : "1px solid #000000" , verticalAlign : "top" ,width : "50%" }}>
                          <Typography sx = {{textWrap : "nowrap",color : item.DR_AMT == "0.00" ? "#adff00" : "#ff0400"}}>{item.DR_AMT == "0.00" ? `${parseFloat(item.CR_AMT).toFixed(2)} Cr` : `${parseFloat(item.DR_AMT).toFixed(2)} Dr`}</Typography>
                          <Grid display="flex" justifyContent="end" flexWrap= "wrap">
                          <Typography sx = {{color : "#999999" , fontSize : "14px"}}>Balance</Typography>
                          <Typography sx = {{color : "#5FCEFF", marginLeft : "5px"}}>{parseFloat(item.CLOSING_AMT).toFixed(2)}</Typography>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    )
                  })}
            </TableBody>
          </Table>
        )}
        <Grid sx={{display : "flex",justifyContent : "center" , padding : "10px 0px 10px 0px"}}>
            <Pagination showFirstButton showLastButton count={Math.ceil(data.length / 5)} size="small" page={mpage} 
              onChange={handleMPageChange} />
            </Grid>
        </> :
        <> 
        
          <Toolbar
            sx={{
              bgcolor: '#1F1741',
              width: "100%",
              paddingLeft: 0,
              paddingRight: 0,
              marginLeft: -3,
              marginRight: 0,
              justifyContent: 'start'
            }}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}>
              <DatePicker
                label="From"
                size="small"
                // removed unnecessary props -30-07-24 - Dev Srini
                sx={{ height: 40, "& .MuiInputBase-root": { height: 40 }, backgroundColor: "#131E2E", marginRight: 1, "& .MuiOutlinedInput-notchedOutline": { border: "none" } }}
                value={dayjs(fromDate)}
                onChange={(newValue) => handleFromDateChange(newValue)} // adjusted date value -30-07-24 - Dev Srini
                renderInput={(props) => (
                  <TextField
                    {...props}
                    sx={{
                      height: 40,
                      '& .MuiInputBase-root': { height: 40 },
                      backgroundColor: '#131E2E',
                      marginRight: 1,
                      '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                    }}
                  />
                )}
                format="DD/MM/YYYY"
                minDate={dayjs(`${startYear}-04-01`)}
                maxDate={dayjs(`${endYear}-03-31`)}
                // Fn year range controlled -30-07-24 - Dev Srini
              />
              <DatePicker
                label="To"
                size="small"
                // removed unnecessary props -30-07-24 - Dev Srini
                sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginRight: 1, "& .MuiOutlinedInput-notchedOutline": { border: "none" } }}
                value={dayjs(new Date( toDate))}
                onChange={(newValue) => handleToDateChange(newValue)} // Adjusted date format -30-07-24 - Dev Srini
                slotProps={{ textField: { size: 'small' } }}
                renderInput={(props) => (
                  <TextField
                    {...props}
                    sx={{
                      height: 40,
                      '& .MuiInputBase-root': { height: 40 },
                      backgroundColor: '#131E2E',
                      marginRight: 1,
                      '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                    }}
                  />
                )}
                format="DD/MM/YYYY"
                minDate={dayjs(`${startYear}-04-01`)}
                maxDate={dayjs(`${endYear}-03-31`)}
                // Fn year range controlled -30-07-24 - Dev Srini
              />    
            </LocalizationProvider>
            {/* <TextField
              label="Client Code"
              variant="outlined"
              placeholder='Client Code'
              size='small'
              sx={{ "& .MuiOutlinedInput-notchedOutline": { border: "none" }, background: "#131E2E", marginRight: "1px" }}
            />
            <TextField
              label="Exchange"
              variant="outlined"
              placeholder='Exchange'
              size='small'
              sx={{"& .MuiOutlinedInput-notchedOutline": { border: "none" }, background: "#131E2E", margin: "0px 1px 0px 5px" }}
            /> */}
            <Button
              sx={{ width: 150, height: 40, margin: "0px 1px 0px 5px" , fontWeight : "bold"}}
              variant="contained"
              size="medium"
              className={styles.mainbutton}
              onClick={() => handleSubmit()}
            >Submit</Button>
            {/* <Button
              variant="outlined"
              size="medium"
              sx={{
                width: 150, height: 40, margin: "0px 1px 0px 5px"
              }}
              className={styles.outlinedButton}
              onClick={() => handleDownload()}
            >Download</Button> */}
          </Toolbar>
          {/* <FormGroup>
            <FormControlLabel
              control={<Checkbox sx={{ color: "#1B2636", marginLeft: "5px" }} />}
              label="With Margin A/C"
            />
          </FormGroup> */}
          <Grid sx={{display : "flex", justifyContent : "end"}}> 
            <Button onClick={() => handleDownload()}
             sx={{background : "transparent" , color : "#F3D45E" , textDecoration : "underline"}}>Download CSV</Button>
            <Button onClick={() => handlePDFDownload()}
             sx={{background : "transparent" , color : "#F3D45E" , textDecoration : "underline"}}>Download PDF</Button>
          </Grid>
          <TableContainer component={Paper} className={styles.tablecontainer} sx={customScrollbarStyles} >
          {data.length == 0 ? (
             <Table > 
             <TableRow  style={{display:'flex',justifyContent:'center',marginTop : "20px"}}>          
               <Alert severity="warning" style={{background:'transparent'}}>No Data found !</Alert>
             </TableRow>
            </Table>
          ):(<Table sx={{ background: "#1F1741", marginTop: "5px", borderRadius: "10px", width: "100%" }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell  className={styles.tablecellheader} key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column) => (
                    <TableCell
                      className={`${styles.tablecell} ${column.id === 'DR_AMT' && styles.tablecelllow} ${column.id === 'CR_AMT' && styles.tablecellhigh} ${column.id === 'CLOSING_AMT' && styles.tablecellmedium}`}
                      key={column.id}>
                      {
                        column.id === "PUNCH_TIME" ? (row[column.id] && new Date(row[column.id]).toLocaleDateString('en-GB')) :
                          (column.id === "CLOSING_AMT" || column.id === "CR_AMT" || column.id === "DR_AMT") ? (parseFloat(row[column.id]).toFixed(2)) :
                            row[column.id]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>)}
        </TableContainer>
          {data.length > 0 && <TablePagination 
              sx= {{background : "#1F1741"}}
              rowsPerPageOptions={[10, 20, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              count={data.length} 
              component="div"
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange} 
              showFirstButton
              showLastButton
          />}
        </>
    }
    <MyModal canShow={showmodal}/>
    <MyLodder canShow={showlodder}/>
  </>
  );
};

export default DetailsList;
